export const useTokenPriority = (): string[] => {
    if (window.location.host === 'quick.spritz.finance') {
        return ['QUICK']
    }

    return []
}
